import React from 'react';
import {
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Telegram as TelegramIcon,
} from '@mui/icons-material';

import { PLATFORM_CONTACT } from './platform.constants';

export const CONTACT_DETAILS = [
  {
    icon: <EmailIcon sx={{ color: 'primary.main' }} />,
    label: 'Email Support',
    value: PLATFORM_CONTACT.SUPPORT_EMAIL,
    href: `mailto:${PLATFORM_CONTACT.SUPPORT_EMAIL}`,
  },
  {
    icon: <TelegramIcon sx={{ color: 'primary.main' }} />,
    label: 'Connect on Telegram',
    value: '@scporvenix',
    href: PLATFORM_CONTACT.TELEGRAM_CONTACT_US,
  },
  // {
  //   icon: <LocationIcon sx={{ color: 'primary.main' }} />,
  //   label: 'Our Headquarters',
  //   value: PLATFORM_CONTACT.HEADQUARTERS,
  //   href: PLATFORM_CONTACT.GOOGLE_MAPS_LINK,
  // },
];
